import * as React from "react";
import {
  Datagrid,
  List,
  Show,
  Create,
  Edit,
  Filter,
  SimpleShowLayout,
  SimpleForm,
  TextField,
  TextInput,
  ShowButton,
  EditButton,
  DateTimeInput,
  SelectInput,
} from "react-admin";
import { CustomDeleteButton } from './CustomDeleteButtons';

const CompetitionFilter = (props) => (
  <Filter {...props}>
    <TextInput label="Search" source="name" alwaysOn />
  </Filter>
);

export const CompetitionList = (props) => (
  <List {...props} filters={<CompetitionFilter />}>
    <Datagrid>
      <TextField source="name" label="Competition Name" />
      <TextField source="type" label="Competition Type" />
      <TextField source="start_date" label="Start Date" />
      <TextField source="end_date" label="End Date" />
      <ShowButton label="" />
      <EditButton label="" />
      <CustomDeleteButton label="" redirect={false}/>
    </Datagrid>
  </List>
);

export const CompetitionShow = (props) => (
  <Show {...props}>
    <SimpleShowLayout>
      <TextField source="id" label="ID" />
      <TextField source="name" label="Competition Name" />
      <TextField source="type" label="Competition Type" />
      <TextField source="start_date" label="Start Date" />
      <TextField source="end_date" label="End Date" />
    </SimpleShowLayout>
  </Show>
);

export const CompetitionCreate = (props) => (
  <Create {...props}>
    <SimpleForm>
      <TextInput source="name" label="Competition Name" />
      <SelectInput source="type" label="Competition Type" choices={[
        { id: 'weekly', name: 'Weekly' },
        { id: 'monthly', name: 'Monthly' },
        { id: 'yearly', name: 'Yearly' },
      ]} />
      <DateTimeInput source="start_date" label="Start Date" />
      <DateTimeInput source="end_date" label="End Date" />
    </SimpleForm>
  </Create>
);

export const CompetitionEdit = (props) => (
  <Edit {...props}>
    <SimpleForm>
      <TextInput source="name" label="Competition Name" />
      <SelectInput source="type" label="Competition Type" choices={[
        { id: 'weekly', name: 'Weekly' },
        { id: 'monthly', name: 'Monthly' },
        { id: 'yearly', name: 'Yearly' },
      ]} />
      <DateTimeInput source="start_date" label="Start Date" />
      <DateTimeInput source="end_date" label="End Date" />
    </SimpleForm>
  </Edit>
); 